// src/redux/actions/siteActions.js
export const SET_TEMP_NAME = 'SET_TEMP_NAME';

export const setTempnameList = (tempnameList) => ({
  type: SET_TEMP_NAME,
  payload: tempnameList,
});
